import { StarIcon } from "@heroicons/react/solid";
import {React} from "react";

export default function Vivencias(){
    return(
        <div className="imgVivencias">
            <div className="flex flex-row justify-center my-5">
                <h1 className="font-bold text-green-400 text-3xl">Vivencias</h1>
            </div>
            <div className="flex flex-row justify-center my-5 p-5 lg:p-10">
                <div className="grid grid-cols-1 gap-6 lg:gap-8 lg:grid-cols-3">
                    <ul className="space-y-8">
                        <li className="text-sm leading-6">
                            <figure className="relative flex flex-col-reverse bg-white rounded-lg p-6 ">
                                <blockquote className="mt-6 text-green-400 flex justify-end">
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                </blockquote>
                                <figcaption className="flex items-center space-x-4">
                                    <img src="/images/person_1.jpg" className="flex-none w-14 h-14 rounded-full object-cover" alt="paquetes y promociones viajes manguen"></img>
                                    <div className="flex-auto">
                                        <div className="text-base font-semibold text-green-400">
                                            Irma Sánchez
                                        </div>
                                        <div className="mt-0.5">
                                            <p>Viaje al puerto de Acapulco y en cuento a reservación, hotel y transporte, la atención fue personalizada a mi presupuesto 
                                                y mis requerimientos de viaje, lo que se platicó fue lo que recibí en mi viaje, pasando unas vacaciones sin contratiempos 
                                                y muy agradables con mi familia.
                                            </p>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                        </li>
                        <li className="text-sm leading-6">
                            <figure className="relative flex flex-col-reverse bg-white rounded-lg p-6 ">
                                <blockquote className="mt-6 text-green-400 flex justify-end">
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                </blockquote>
                                <figcaption className="flex items-center space-x-4">
                                    <img src="/images/person_2.jpg" className="flex-none w-14 h-14 rounded-full object-cover" alt="paquetes y promociones viajes manguen"></img>
                                    <div className="flex-auto">
                                        <div className="text-base font-semibold text-green-400">
                                            Angélica Teodoro
                                        </div>
                                        <div className="mt-0.5">
                                            <p>Desde el momento en que salí del aeropuerto toda la documentación, las personas que me recibieron para trasladarme al hotel,
                                                los guías, todo de principio a fin estuvo muy bien organizado y la atención siempre fue muy agradable, todos los lugares que visitamos
                                                estuvieron muy bonitos, quede muy contenta con el servicio de la agencia.  
                                            </p>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                        </li>
                        <li className="text-sm leading-6">
                            <figure className="relative flex flex-col-reverse bg-white rounded-lg p-6 ">
                                <blockquote className="mt-6 text-green-400 flex justify-end">
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                </blockquote>
                                <figcaption className="flex items-center space-x-4">
                                    <img src="/images/person_3.jpg" className="flex-none w-14 h-14 rounded-full object-cover" alt="paquetes y promociones viajes manguen"></img>
                                    <div className="flex-auto">
                                        <div className="text-base font-semibold text-green-400">
                                            Alejandra Morales
                                        </div>
                                        <div className="mt-0.5">
                                            <p>Excelente servicio y atención</p>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                        </li>
                    </ul>
                    <ul className="space-y-8">
                        <li className="text-sm leading-6">
                            <figure className="relative flex flex-col-reverse bg-white rounded-lg p-6 ">
                                <blockquote className="mt-6 text-green-400 flex justify-end">
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                </blockquote>
                                <figcaption className="flex items-center space-x-4">
                                    <img src="/images/person_4.jpg" className="flex-none w-14 h-14 rounded-full object-cover" alt="paquetes y promociones viajes manguen"></img>
                                    <div className="flex-auto">
                                        <div className="text-base font-semibold text-green-400">
                                            Verónica Martínez
                                        </div>
                                        <div className="mt-0.5">
                                            <p>Mi viaje me gusto mucho, está muy organizado y los hoteles donde nos hospedan son de primera, y quedamos satisfechos 
                                                con la atención que nos brindan. 
                                            </p>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                        </li>
                        <li className="text-sm leading-6">
                            <figure className="relative flex flex-col-reverse bg-white rounded-lg p-6 ">
                                <blockquote className="mt-6 text-green-400 flex justify-end">
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                </blockquote>
                                <figcaption className="flex items-center space-x-4">
                                    <img src="/images/person_5.jpg" className="flex-none w-14 h-14 rounded-full object-cover" alt="paquetes y promociones viajes manguen"></img>
                                    <div className="flex-auto">
                                        <div className="text-base font-semibold text-green-400">
                                            Oswaldo Martínez
                                        </div>
                                        <div className="mt-0.5">
                                            <p>Muy buen trato y muy confiable, me sentí muy feliz al salir de lo rutinario, volveré a visitar otros lugares.</p>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                        </li>
                        <li className="text-sm leading-6">
                            <figure className="relative flex flex-col-reverse bg-white rounded-lg p-6 ">
                                <blockquote className="mt-6 text-green-400 flex justify-end">
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                </blockquote>
                                <figcaption className="flex items-center space-x-4">
                                    <img src="/images/person_6.jpg" className="flex-none w-14 h-14 rounded-full object-cover" alt="paquetes y promociones viajes manguen"></img>
                                    <div className="flex-auto">
                                        <div className="text-base font-semibold text-green-400">
                                            Joaquin Aguirre
                                        </div>
                                        <div className="mt-0.5">
                                            <p>La agencia hizo todo para que nuestra estancia fuera 100% agradable. 
                                                La pasamos muy bien y recomendamos completamente sus servicios. 
                                                Siempre hemos hecho viajes con la agencia y todos han sido muy satisfechos.</p>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                        </li>
                    </ul>
                    <ul className="space-y-8">
                         <li className="text-sm leading-6">
                            <figure className="relative flex flex-col-reverse bg-white rounded-lg p-6 ">
                                <blockquote className="mt-6 text-green-400 flex justify-end">
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                </blockquote>
                                <figcaption className="flex items-center space-x-4">
                                    <img src="/images/person_7.jpg" className="flex-none w-14 h-14 rounded-full object-cover" alt="paquetes y promociones viajes manguen"></img>
                                    <div className="flex-auto">
                                        <div className="text-base font-semibold text-green-400">
                                            María Graciela Martínez
                                        </div>
                                        <div className="mt-0.5">
                                            <p>Mi experiencia con la agencia ha sido muy agradable por que brinda los mejores servicios 
                                                y sobre todo trabaja con mucha horadez y eficasia.</p>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                        </li>
                        <li className="text-sm leading-6">
                            <figure className="relative flex flex-col-reverse bg-white rounded-lg p-6 ">
                                <blockquote className="mt-6 text-green-400 flex justify-end">
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                    <StarIcon className="w-5 h-5 text-green-400"></StarIcon>
                                </blockquote>
                                <figcaption className="flex items-center space-x-4">
                                    <img src="/images/person_8.jpg" className="flex-none w-14 h-14 rounded-full object-cover" alt="paquetes y promociones viajes manguen"></img>
                                    <div className="flex-auto">
                                        <div className="text-base font-semibold text-green-400">
                                            Omar H.
                                        </div>
                                        <div className="mt-0.5">
                                            <p>Estuvimos en el Hotel Azul beach resort, en la riviera de Cancún, el vuelo fue agradable, 
                                                pero el transporte al hotel es un poco lento, hubo un momento que después de 30 minutos que anduvimos buscando 
                                                al personal para saber que pasaba, el chofer no conocía donde estaba el hotel, porque dio dos vueltas; 
                                                el hotel es muy bonito, la atención muy buena, la habitación impecable, la comida estuvo maravillosa en todos los 
                                                lugares donde fuimos, los mojitos de canela INIGUALABLES.Hubiéramos conocido más si al llegar nos hubieran dicho 
                                                al llegar había que acudir con el concierge para reservar la cena y actividades, nunca tuve señal en mi celular, 
                                                solo mensajería instantánea por aplicación, hicimos yoga en la playa, andamos en el mar con todo y el sargazo 
                                                y básicamente descansamos bastante, conocimos muchas personas y fue una gran experiencia.</p>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                        </li>
                    </ul>                       
                </div>
            </div>
        </div>
    )
}